import { PaginationProps } from '../interfaces/index';

export enum LANGUAGES {
  VI = 'vi',
  US = 'en-US',
}

export const MOBILE_SIZE_LIMIT = 600;

export const STUDY_OPENING = 'study_opening';
export const PERMISSION_LOADING = 'PERMISSION_LOADING';
export const HOVER_BOX_TIMER = 500; // 500 mini seconds
export const DEBOUNCE_WAIT = 500;

export const CONFIG_SERVER = {
  BACKEND_URL: (process.env.BACKEND_URL || window.origin) + '/api/ris',
  AUTH_URL: process.env.AUTH_URL || window.origin,
  DISABLE_AUTH: process.env.DISABLE_AUTH === 'true',
  WEBSOCKET_URL: process.env.WEBSOCKET_URL,
  REDIRECT_URI: process.env.REDIRECT_URI || window.origin,

  SCOPE: process.env.OIDC_SCOPE || 'profile',

  OIDC_ACCESS_TOKEN_URI: process.env.OIDC_ACCESS_TOKEN_URI,
  OIDC_LOGOUT_URI: process.env.OIDC_LOGOUT_URI,
  OIDC_USERINFO_ENDPOINT: process.env.OIDC_USERINFO_ENDPOINT,
  OIDC_REDIRECT_URI: process.env.OIDC_REDIRECT_URI || window.origin,
  STATE: Math.random().toString(36).substring(2),
  OIDC_AUTHORIZATION_URI: process.env.OIDC_AUTHORIZATION_URI,
  AUDIENCE: process.env.OIDC_AUDIENCE || 'vindr-api',
  RESPONSE_TYPE: 'code',
  CLIENT_ID: process.env.OIDC_CLIENT_ID || 'vindr-frontend',
  REALM_ID: process.env.REALM_ID || window.config?.realmId || 'vna-prod-aws',
};

export const documentS3Url = window.PUBLIC_URL + 'HDSD.pdf'; // 'https://vindoc-public.s3.ap-southeast-1.amazonaws.com/TELERAD_HDSD.pdf';
export const SURVEY_URL = 'https://bit.ly/telerad-survey';

export const PAGINATION = Object.freeze({
  PAGE: 1,
  PAGE_SIZE: 25,
  PAGE_SIZE_OPTIONS: [10, 25, 50, 100],
});

export const INIT_PAGINATION: PaginationProps = {
  page: PAGINATION.PAGE,
  size: PAGINATION.PAGE_SIZE,
};

export const INIT_PAGINATION_PARAM = {
  offset: PAGINATION.PAGE - 1,
  limit: PAGINATION.PAGE_SIZE,
};

export enum GENDER {
  Male,
  Female,
  Other,
}

export enum SHORT_GENDER {
  M,
  F,
  O,
}

export enum DEVICES {
  Modality = 0,
  Connector = 1,
  MWL = 2,
  DICOM_Printer = 3,
  Cache = 4,
}

export const DEVICE_TYPE = [
  { label: 'Connector', value: DEVICES.Connector },
  { label: 'Modality', value: DEVICES.Modality },
  { label: 'DICOM Printer', value: DEVICES.DICOM_Printer },
  { label: 'Cache', value: DEVICES.Cache },
];

export enum DeviceTypes {
  Modality = 0,
  Connector = 1,
  MWL = 2,
}

// export enum SortOrder {
//   ASC = 0,
//   DESC = 1,
// }

export const STATUS_ACTIVE = {
  ACTIVE: true,
  INACTIVE: false,
};

export enum LAYOUT_TYPE {
  PRIVATE,
  PUBLIC,
}

export enum MODALITIES {
  CR = 'CR',
  DX = 'DX',
  DR = 'DR',
  CT = 'CT',
  MR = 'MR',
  MG = 'MG',
  US = 'US',
  ES = 'ES',
  PT = 'PT',
  ST = 'ST',
  XA = 'XA',
  SR = 'SR',
  SM = 'SM',
  OT = 'OT',
  ESTMH = 'ESTMH',
  IVF = 'IVF',
  BMD = 'BMD',
  TVSH = 'TVSH',
}

export enum ACCOUNT_STATUS {
  Inactive,
  Active,
  Expired,
}

export enum Share_Type {
  Guest,
  HIS,
}

export enum AGENCY {
  VINMEC = 'vinmec',
  VINDR = 'vindr',
}

export const DEFAULT_URL_UPLOAD =
  process.env.NODE_ENV === 'development'
    ? process.env.AUTH_URL
    : window.location.origin;

export enum MIME_TO_EXTENSION {
  'audio/x-mpeg' = <any>'mpega',
  'application/postscript' = <any>'ps',
  'audio/x-aiff' = <any>'aiff',
  'application/x-aim' = <any>'aim',
  'image/x-jg' = <any>'art',
  'video/x-ms-asf' = <any>'asx',
  'audio/basic' = <any>'ulw',
  'video/x-msvideo' = <any>'avi',
  'video/x-rad-screenplay' = <any>'avx',
  'application/x-bcpio' = <any>'bcpio',
  'application/octet-stream' = <any>'exe',
  'image/bmp' = <any>'dib',
  'text/html' = <any>'html',
  'application/x-cdf' = <any>'cdf',
  'application/pkix-cert' = <any>'cer',
  'application/java' = <any>'class',
  'application/x-cpio' = <any>'cpio',
  'application/x-csh' = <any>'csh',
  'text/css' = <any>'css',
  'application/xml-dtd' = <any>'dtd',
  'video/x-dv' = <any>'dv',
  'application/x-dvi' = <any>'dvi',
  'application/vnd.ms-fontobject' = <any>'eot',
  'text/x-setext' = <any>'etx',
  'image/gif' = <any>'gif',
  'application/x-gtar' = <any>'gtar',
  'application/x-gzip' = <any>'gz',
  'application/x-hdf' = <any>'hdf',
  'application/mac-binhex40' = <any>'hqx',
  'text/x-component' = <any>'htc',
  'image/ief' = <any>'ief',
  'text/vnd.sun.j2me.app-descriptor' = <any>'jad',
  'application/java-archive' = <any>'jar',
  'text/x-java-source' = <any>'java',
  'application/x-java-jnlp-file' = <any>'jnlp',
  'image/jpeg' = <any>'jpg',
  'application/javascript' = <any>'js',
  'text/plain' = <any>'txt',
  'application/json' = <any>'json',
  'audio/midi' = <any>'midi',
  'application/x-latex' = <any>'latex',
  'audio/x-mpegurl' = <any>'m3u',
  'image/x-macpaint' = <any>'pnt',
  'text/troff' = <any>'tr',
  'application/mathml+xml' = <any>'mathml',
  'application/x-mif' = <any>'mif',
  'video/quicktime' = <any>'mov',
  'video/x-sgi-movie' = <any>'movie',
  'video/webm' = <any>'webm',
  'audio/mpeg' = <any>'mpa',
  'video/mp4' = <any>'mp4',
  'video/mpeg' = <any>'mpg',
  'video/mpeg2' = <any>'mpv2',
  'application/x-wais-source' = <any>'src',
  'application/x-netcdf' = <any>'nc',
  'application/oda' = <any>'oda',
  'application/vnd.oasis.opendocument.database' = <any>'odb',
  'application/vnd.oasis.opendocument.chart' = <any>'odc',
  'application/vnd.oasis.opendocument.formula' = <any>'odf',
  'application/vnd.oasis.opendocument.graphics' = <any>'odg',
  'application/vnd.oasis.opendocument.image' = <any>'odi',
  'application/vnd.oasis.opendocument.text-master' = <any>'odm',
  'application/vnd.oasis.opendocument.presentation' = <any>'odp',
  'application/vnd.oasis.opendocument.spreadsheet' = <any>'ods',
  'application/vnd.oasis.opendocument.text' = <any>'odt',
  'application/vnd.oasis.opendocument.graphics-template' = <any>'otg',
  'application/vnd.oasis.opendocument.text-web' = <any>'oth',
  'application/vnd.oasis.opendocument.presentation-template' = <any>'otp',
  'application/vnd.oasis.opendocument.spreadsheet-template' = <any>'ots',
  'application/vnd.oasis.opendocument.text-template' = <any>'ott',
  'application/ogg' = <any>'ogx',
  'video/ogg' = <any>'ogv',
  'audio/ogg' = <any>'spx',
  'application/x-font-opentype' = <any>'otf',
  'audio/flac' = <any>'flac',
  'application/annodex' = <any>'anx',
  'audio/annodex' = <any>'axa',
  'video/annodex' = <any>'axv',
  'application/xspf+xml' = <any>'xspf',
  'image/x-portable-bitmap' = <any>'pbm',
  'image/pict' = <any>'pict',
  'application/pdf' = <any>'pdf',
  'image/x-portable-graymap' = <any>'pgm',
  'audio/x-scpls' = <any>'pls',
  'image/png' = <any>'png',
  'image/x-portable-anymap' = <any>'pnm',
  'image/x-portable-pixmap' = <any>'ppm',
  'image/vnd.adobe.photoshop' = <any>'psd',
  'image/x-quicktime' = <any>'qtif',
  'image/x-cmu-raster' = <any>'ras',
  'application/rdf+xml' = <any>'rdf',
  'image/x-rgb' = <any>'rgb',
  'application/vnd.rn-realmedia' = <any>'rm',
  'application/rtf' = <any>'rtf',
  'text/richtext' = <any>'rtx',
  'application/font-sfnt' = <any>'sfnt',
  'application/x-sh' = <any>'sh',
  'application/x-shar' = <any>'shar',
  'application/x-stuffit' = <any>'sit',
  'application/x-sv4cpio' = <any>'sv4cpio',
  'application/x-sv4crc' = <any>'sv4crc',
  'image/svg+xml' = <any>'svgz',
  'application/x-shockwave-flash' = <any>'swf',
  'application/x-tar' = <any>'tar',
  'application/x-tcl' = <any>'tcl',
  'application/x-tex' = <any>'tex',
  'application/x-texinfo' = <any>'texinfo',
  'image/tiff' = <any>'tiff',
  'text/tab-separated-values' = <any>'tsv',
  'application/x-font-ttf' = <any>'ttf',
  'application/x-ustar' = <any>'ustar',
  'application/voicexml+xml' = <any>'vxml',
  'image/x-xbitmap' = <any>'xbm',
  'application/xhtml+xml' = <any>'xhtml',
  'application/xml' = <any>'xsl',
  'image/x-xpixmap' = <any>'xpm',
  'application/xslt+xml' = <any>'xslt',
  'application/vnd.mozilla.xul+xml' = <any>'xul',
  'image/x-xwindowdump' = <any>'xwd',
  'application/vnd.visio' = <any>'vsd',
  'audio/x-wav' = <any>'wav',
  'image/vnd.wap.wbmp' = <any>'wbmp',
  'text/vnd.wap.wml' = <any>'wml',
  'application/vnd.wap.wmlc' = <any>'wmlc',
  'text/vnd.wap.wmlsc' = <any>'wmls',
  'application/vnd.wap.wmlscriptc' = <any>'wmlscriptc',
  'video/x-ms-wmv' = <any>'wmv',
  'application/font-woff' = <any>'woff',
  'application/font-woff2' = <any>'woff2',
  'model/vrml' = <any>'wrl',
  'application/wspolicy+xml' = <any>'wspolicy',
  'application/x-compress' = <any>'z',
  'application/zip' = <any>'zip',

  'application/vnd.openxmlformats-officedocument.wordprocessingml.document' = <any>'docx',
  'application/msword' = <any>'doc',
  'application/vnd.openxmlformats-officedocument.presentationml.presentation' = <any>'pptx',
  'application/vnd.ms-powerpoint' = <any>'ppt',
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' = <any>'xlsx',
  'application/vnd.ms-excel' = <any>'xls',
}

export const STATUS_COLOR = {
  APPROVED: '#5e9148',
  NEW: '#5d6979',
  ARRIVED: '#8e44ad',
  COMPLETED: '#2980b9',
  READING: '#c4b715',
  PENDING: '#b23b00',
  SUBMITTED: '#b23b00',
};
